import { render, staticRenderFns } from "./BlogSingle.vue?vue&type=template&id=0ddf91ac&"
import script from "./BlogSingle.vue?vue&type=script&lang=js&"
export * from "./BlogSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports